import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ActivityCompletion from "src/views/Pages/Dashboard/Grow/Reports/ActivityCompletion/ActivityCompletion.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const ActivityCompletionRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'activitycompletion',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.activity_completion',
          component: ActivityCompletion,
          meta: {
            prefix_permission: 'grow_activitycompletion',
          },
        },
      ],
    },
  ],
};

export default ActivityCompletionRoutes;